import 'babel-polyfill';
import 'angular';
import 'angular-ui-router';
import 'angular-animate';
import 'angular-ui-bootstrap';
import 'angular-aria';
import 'angular-material';
import 'angular-google-chart';
import 'redux';



// WEBPACK FOOTER //
// ./src/vendor.js